// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"7e649b0d","196":"9ca32696","209":"df1c632a","330":"a716a006","453":"3f97b0be","640":"0b10caec","659":"eb6b6e9e","735":"b70c7fc7","846":"1264d925"}[chunkId] + ".chunk.js";
};